<template>
  <div
    :key="id"
    class="rounded-lg flex justify-between relative max-w-72 py-3 px-4 bg-background-highlight text-white"
  >
    <div class="flex gap-x-2 cursor-pointer" @click="openGeneration">
      <AdvanceImage
        class="w-[30px] h-[38px] rounded overflow-hidden"
        img-class="w-full h-full object-cover"
        container-class="w-full h-full"
        :src="thumbnail"
      />
      <div class="flex flex-col gap-y-1">
        <h4
          class="text-sm font-medium w-full text-left flex gap-x-1 items-center"
        >
          <span>{{ title }}</span>
        </h4>
        <p v-if="description" class="text-xs text-left">
          {{ description }}
        </p>
      </div>
    </div>
    <div
      class="px-1 py-1 absolute -top-1 -right-1 h-max bg-background-highlight rounded-full cursor-pointer"
      @click="closeSonner"
    >
      <Icon icon="ri:close-line" height="16" />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { Icon } from "@iconify/vue";
import { openGenerationSidebar } from "@/lib/utils.js";
import AdvanceImage from "@/components/common/AdvanceImage.vue";

// Define props and emits for the toast
const props = defineProps({
  id: String,
  message: String,
  action: Object,
  onDismiss: Function,
  title: String,
  description: String,
  thumbnail: String,
});

const emit = defineEmits(["closeToast"]);

// Dismiss the toast by emitting the 'closeToast' event
function closeSonner() {
  if (props.onDismiss) props.onDismiss({ id: props.id });
  emit("closeToast");
}

function openGeneration() {
  openGenerationSidebar.next();
  closeSonner();
}
</script>
